import React, {useState} from "react";
import {
    Create,
    FormTab,
    TextInput,
    TabbedForm,
    Toolbar,
    ReferenceInput,
    NumberInput
} from 'react-admin';
import Typography from '@material-ui/core/Typography';
import {makeStyles} from "@material-ui/core";
import SaveIcon from '@material-ui/icons/Save';


const useStyles = makeStyles((theme) => ({
    provincia: {display: 'inline-block', width: 200, marginLeft: 8},
    cod_afip: {display: 'inline-block', width: 400, marginLeft: 8},
}));

const PostCreateToolbar = props => {
    return (
        <Toolbar {...props} >

        </Toolbar>
    )

};

const validateCreate = (values) => {
    const errors = {};

    var w_provincia = values.provincia

    if (w_provincia===undefined) {
        errors.provincia = ['El campo Código es requerido'];
    }else {
        if (w_provincia === null) {
            errors.provincia = ['El campo Código es requerido'];
        } else {
            w_provincia = w_provincia.trim()
            if (w_provincia === '') {
                errors.provincia = ['El campo Código es requerido'];
            }
        }
    }


    var w_cod_afip = values.cod_afip

    if (w_cod_afip===undefined) {
        errors.cod_afip = ['El campo Descripcion es requerido'];
    }else {
        if (w_cod_afip === null) {
            errors.cod_afip = ['El campo Descripcion es requerido'];
        } else {
            w_cod_afip = w_cod_afip.trim()
            if (w_cod_afip === '') {
                errors.cod_afip = ['El campo Descripcion es requerido'];
            }
        }
    }





    return errors
};

// redirect to the related Author show page
const redirect = (basePath, id, data) => `/Provincia`;

const ProvinciaCreate = props => {
    const classes = useStyles();

    const PostTitle = ({record}) => {
        return <span>Alta de Provincia</span>;
    };

    return (
        <Create title={<PostTitle/>} {...props}>
            <TabbedForm
                // toolbar={<PostCreateToolbar />} validate={validateCreate} redirect={redirect}
            >
                {/*Datos*/}
                <FormTab label="DATOS PROVINCIA">
                    <TextInput
                        label="Provincia"
                        source="provincia"
                        formClassName={classes.provincia}
                        placeholder="Ingrese Provincia"
                        helperText="Provincia"
                        margin="normal"
                        InputLabelProps={{
                            shrink: true,
                        }}
                        variant="outlined"
                    />

                    <br/>

                    <TextInput
                        id="standard-full-width"
                        label="Código AFIP"
                        source="cod_afip"
                        formClassName={classes.cod_afip}
                        multiline
                        placeholder="Ingrese Código AFIP"
                        helperText="Código AFIP"
                        fullWidth
                        margin="normal"
                        InputLabelProps={{
                            shrink: true,
                        }}
                        variant="outlined"
                    />
                    <br/>

                </FormTab>
            </TabbedForm>
        </Create>
    )
};
export default ProvinciaCreate;


